import React from 'react';
import { motion } from 'framer-motion';

// Parent container variants to manage the sequence (stagger) of children
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

// Item variants for text elements
const textVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

// Specific stagger for the three statistics columns
const rowVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15, // Delay between each of the 3 columns
      delayChildren: 0.5,
    },
  },
};

const columnVariants = {
  hidden: { opacity: 0, scale: 0.9, y: 20 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

const AboutSection = () => {
  return (
    <section className="mb-5">
      <motion.div
        className="container about"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.3 }} // Triggers when 30% visible
      >
        <motion.div variants={textVariants} className="main-heading text-center">
          <span className="outline-text">Axe</span>
          <span className='custom-seell'>sell Your{" "}</span>
          <span className="script-text">Growth</span>{" "}
          With <span className="highlight-text">Us</span>
        </motion.div>
 

       <div  className='row justify-content-center align-items-center'>
        <div  className='col-lg-10'>
            <p  className='custom-about-sec-axe'>We help businesses build modern, high-performing, and visually engaging websites designed to grow their brand online. From custom layouts to advanced functionality, every website is crafted to match your business goals and customer experience. Our team specializes in creating fully customized and scalable website solutions with clean UI/UX, responsive design. </p>
        </div>
       </div>
      


      </motion.div>
    </section>
  );
};

export default AboutSection;